if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    $(".expand-more").click(function (e) {
      e.preventDefault();
      var expand_text = $(this).attr('href');
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(expand_text).slideToggle();
        $(this).text('Learn More');
      } else {
        $(this).addClass("active");
        $(expand_text).slideToggle();
        $(this).text("View Less");
      }
    });

    $('.sym-slides').slick();

     //fancybox
     $('.fancybox-terms').fancybox({
        wrapCSS : 'full-fancy-copy',
        maxWidth: 800,
    }); 

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
    const menu = document.querySelector('#booking-section');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .social-media a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#booking-section');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});